// NPM Imports
import React, { Component, Suspense, Fragment } from "react";
import { connect } from "react-redux";

// Components Imports
import StatusDropdown from "./StatusDropdown";
import { GlobalUtils } from "../../utils";
import { LazyLoad } from "../../commonComponents";
import LZLoader from "../../commonComponents/LZLoader";

const QuotationTopbarInfoLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "quotation-topbar-info-page" */ "./QuotationTopbarInfo"
  ),
);
const QuotationTopBarV2Lazy = LazyLoad(() =>
  import(/* webpackChunkName: "quotation-topbar-v2" */ "../QuotationTopBarV2"),
);
const QuotationTopBarV3Lazy = LazyLoad(() =>
  import(/* webpackChunkName: "quotation-topbar-v3" */ "../QuotationTopBarV3"),
);

const { readDataFromLocalStorage } = GlobalUtils;

// Declarations
const FORM = "form";

// TO_ASH: Change the component to pure func
class QuotationTopbar extends Component {
  state = {
    renderComponents: false,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ renderComponents: true });
    }, 500);
  }

  render() {
    return (
      <div
        data-test="quotationtopbar-documentdetails-topbar-section"
        className="documentdetails-topbar-section">
        {this.state.renderComponents && (
          <Fragment>
            <Suspense fallback={<LZLoader label="Please wait..." largeLabel />}>
              <QuotationTopbarInfoLazy {...this.props} />
              {/* <QuotationTopbarBtns /> */}
              <QuotationTopBarV3Lazy />
              <QuotationTopBarV2Lazy />
            </Suspense>
            {/* Status dropdown */}
            <StatusDropdown
              currentStatus={this.props.documentStatus}
              currentTag={this.props.documentTag}
              docId={this.props.docId}
              source="Document"
            />
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: {
      isLocked,
      template_type: templateType,
      documentStatus,
      documentTag,
      id,
      scope: { write, fill } = {},
      stage,
      docType,
    } = {},
    docRecipientList,
  } = state.DocumentStore;

  const isTemplateTypeForm = templateType === FORM;

  const isDocumenTypeForm = docType === FORM;

  const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
  // For internal user
  const currentUserIsFiller = docRecipientList.some(
    item =>
      item.user &&
      item.user.id &&
      item.user.id === (CURRENT_USER && CURRENT_USER.id) &&
      item.recipient_type === "FILLER",
  );

  let lockedInStage = true;
  if (docType === "master_form") {
    lockedInStage = true;
  } else if (
    stage === "DRAFT" ||
    (stage === "SENT_FOR_FILLING" && currentUserIsFiller)
  ) {
    lockedInStage = false;
  }

  return {
    isLocked: (isLocked && !(write || fill)) || lockedInStage,
    isTemplateTypeForm,
    documentStatus,
    documentTag,
    docId: id,
    isDocumenTypeForm,
  };
};

export default connect(mapStateToProps, null)(QuotationTopbar);
